import { render, staticRenderFns } from "./kro_izq.vue?vue&type=template&id=0656b200&"
import script from "./kro_izq.vue?vue&type=script&lang=js&"
export * from "./kro_izq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports